import { RootStoreState } from 'modules/root'

export const comboBoxUserData = (state: RootStoreState) => state.combobox.userData
export const comboBoxProjectData = (state: RootStoreState) => state.project.currentProject
export const comboBoxData = (state: RootStoreState, code: string) => state.combobox.userData.comboBoxes[code]
